export default __webpack_public_path__ + "static/media/svg-4.a3b803c8.svg";